import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles.scss";
import * as serviceWorker from "./serviceWorker";
const root = document.getElementById("root");
//@ts-ignore
ReactDOM.createRoot(root).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
